module.exports = __webpack_public_path__ + "img/hero-mobile.f9e8ca7e.jpg";